import React, { useState, useEffect } from 'react';
import { useTranslations } from '../../localization/useTranslations';
import { isUserLoggedIn, openLoginModal } from '../../common/Auth';

const SalesFunnelEmbed = () => {
  const [iframeSrc, setIframeSrc] = useState('');
  const [isLocked, setIsLocked] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const translations = useTranslations();

  useEffect(() => {
    function checkAndSetVariables() {
      const crm_url = window.crmUrl || process.env.REACT_APP_CRM_BASE_URI || '';
      const funnel_name = window.forbes_sales_funnel?.funnel_name || '';
      const content_url = window.forbes_last_visited_post?.url || '';
      const content_id = window.forbes_last_visited_post?.id || '';
      const theme = window.forbes_config?.theme || 'light';
      const selectedSubscription = window.forbes_config?.selectedSubscription || '';
      const locked = window.forbes_sales_funnel?.funnel_authentication_required || false;

      if (!funnel_name) {
        setTimeout(checkAndSetVariables, 100);
        return;
      }

      setIsLocked(locked && !isUserLoggedIn());

      const pricingBar = document.querySelector('.page-sales-funnel-pricing__bar');
      if (pricingBar instanceof HTMLElement) {
        pricingBar.style.display = locked && !isUserLoggedIn() ? 'none' : '';

        const pricingBarHeight = pricingBar.offsetHeight;
        document.body.style.marginBottom = `${pricingBarHeight}px`;
      }

      // Encode all dynamic parts of the URL
      const encodedFunnelName = encodeURIComponent(funnel_name);
      const encodedContentUrl = content_url ? encodeURIComponent(content_url) : '';
      const encodedContentId = content_id ? encodeURIComponent(content_id) : '';
      const encodedTheme = encodeURIComponent(theme);

      // Get subscription data from localStorage
      const subscriptionData = localStorage.getItem('subscriptionData');
      const encodedSubscriptionData = subscriptionData ? encodeURIComponent(btoa(subscriptionData)) : '';

      // Construct the iframe URL with conditional inclusion of content_url, content_id, subscriptionData, and selectedSubscription
      let iframeUrl = `${crm_url}/sales-funnel/sales-funnel-frontend/show?funnel=${encodedFunnelName}`;
      if (encodedContentUrl) iframeUrl += `&referer=${encodedContentUrl}`;
      if (encodedContentId) iframeUrl += `%3Farticle_id%3D${encodedContentId}`;
      iframeUrl += `&theme=${encodedTheme}`;
      if (encodedSubscriptionData) iframeUrl += `&payload=${encodedSubscriptionData}`;
      if (selectedSubscription) iframeUrl += `&selectedSubscription=${encodeURIComponent(selectedSubscription)}`;

      setIframeSrc(iframeUrl);
      setIsLoading(false);
    }

    checkAndSetVariables();
  }, []);

  return (
    <div>
      {isLoading ? (
        <div></div>
      ) : isLocked ? (
        <div className="container">
          <p className="h-typography--basic-16" style={{ margin: '4rem 0' }}>
            {translations?.salesFunnelEmbed?.lockedSalesFunnelMessage ||
              'This sales funnel is locked. Please login to access it.'}
          </p>
          <button
            style={{ margin: '4rem 0' }}
            className="button button--medium button--primary"
            onClick={() => openLoginModal()}
          >
            {translations?.authLabels?.login || 'Login'}
          </button>
        </div>
      ) : (
        <iframe
          id="outside"
          src={iframeSrc}
          frameBorder="0"
          scrolling="no"
          width="100%"
          title="Sales Funnel Embed"
        ></iframe>
      )}
    </div>
  );
};

export default SalesFunnelEmbed;
